import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import Chart from 'chart.js/auto';
import { count } from 'rxjs';
import { AnalyticsService } from 'src/app/services/analytics.service';
// import {generateChart} from '../../config/google-geo-chart';
declare var google:any;

@Component({
  selector: 'app-analytics-view',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './analytics-view.component.html',
  styleUrls: ['./analytics-view.component.scss', '../../app.component.scss']
})
export class AnalyticsViewComponent {
  public stocks = [
    {
      name: 'active',
      imgUrl: '../../../assets/images/stocks/active_glow.svg',
      count: 0,
    },
    {
      name: 'consumed',
      imgUrl: '../../../assets/images/cabinet/consumed.svg',
      count: 0,
    },
    {
      name: 'rejected',
      imgUrl: '../../../assets/images/stocks/rejected.svg',
      count: 0,
    },
    {
      name: 'missing',
      imgUrl: '../../../assets/images/cabinet/missing.svg',
      count: 0,
    },
    {
      name: 'transit',
      imgUrl: '../../../assets/images/stocks/transit.svg',
      count: 0,
    },
    {
      name: 'expired',
      imgUrl: '../../../assets/images/cabinet/expired.svg',
      count: 0,
    },
  ];

  public expiredStocks: any;
  public expiringStocks: any;

  public donutLegendStoreType = [];

  // {
  //   label: '',
  //   backgroundColor: '',
  //   count: 0
  // };

  public donutLegendProductType = [];

  public warningMessageConsumedByWeek = "";
  public warningMessageConsumedByStores = "";
  public warningMessageConsumedByProducts = "";
  public warningMessageExpired = "";
  public warningMessageGeoChart = "";
  public warningMessageExpiring = "";

  
  constructor(
    private analyticsService: AnalyticsService
  ){

  }

  ngOnInit(): void{
    this.getStockCounts();
    this.getConsumedByWeek();
    this.getConsumedByStores('consumed');
    this.getConsumedByProducts('body_parts');
    this.getExpired();
    this.getExpiring();
    this.generateGeoChart();
  }

  generateGeoChart(){
    let role = JSON.parse(localStorage.getItem('role'));
  
    this.analyticsService.getStores(role.resource_id, ['id','name','latitude','longitude'], ['cabinets','stocks']).subscribe({
      next: (res) => {
        if (res.data.length !== 0) {
          google.load('visualization', '1', {'packages': ['geochart']});
          google.setOnLoadCallback(drawMarkersMap);
          
          function drawMarkersMap() {
              var data = new google.visualization.DataTable(); 

              data.addColumn('number', 'Lat');                                
              data.addColumn('number', 'Long');
              data.addColumn('string','tooltip'); 
              data.addColumn({type:'string', role:'tooltip', 'p': {'html': true}});
                    
              res.data.forEach((store) => {
                if (store.latitude && store.longitude) {
                  data.addRows([[Number(store.latitude),Number(store.longitude), '', createCustomHTMLContent(store.name, store.cabinets, store.stocks)]]);
                }  
              });
          
              var chart = new google.visualization.GeoChart(document.getElementById('geo-chart'));

              let options = {
                legend: 'none',
                displayMode: 'markers', 
                enableRegionInteractivity: 'true', 
                resolution: 'countries',
                sizeAxis: {minValue: 1, maxValue:1,minSize:5,  maxSize: 5},
                region:'world',
                keepAspectRatio: true,
                tooltip: {isHtml: true, trigger: 'selection', textStyle: {color: '#212529', textAlign: 'center'}}  
              }

              chart.draw(data, options);
          
              google.visualization.events.addOneTimeListener(chart, 'ready', function() {
                  let circle = document.getElementsByTagName('circle');
                  Array.from(circle).forEach((el)=>{
                      el.style.fill = "#00C0EF";
                  })
              });     
          };
          
          function createCustomHTMLContent(storeName, cabinetCount, storeCount){
            return `
                    <span style="display: flex; justify-content: space-between; align-items: center; padding-bottom: 3px; border-bottom: 0.5px solid #0000001A;">${storeName}</span>

                    <span style="display: flex; justify-content: space-between; align-items: center; margin-top: 3px;">
                      <span style="display: flex; align-items: center; gap: 5px;">
                        <svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M18.3346 4.99996V15C18.3346 16.8409 16.8423 18.3333 15.0013 18.3333H10.0013H5.0013C3.16035 18.3333 1.66797 16.8409 1.66797 15V4.99996C1.66797 3.15901 3.16035 1.66663 5.0013 1.66663H10.0013H15.0013C16.8423 1.66663 18.3346 3.15901 18.3346 4.99996Z" fill="#FF7F36"/>
                          <path d="M18.3333 15V4.99996C18.3333 3.15901 16.8409 1.66663 15 1.66663H12.0513C10.9184 1.66663 10 2.58502 10 3.71791V16.282C10 17.4149 10.9184 18.3333 12.0513 18.3333H15C16.8409 18.3333 18.3333 16.8409 18.3333 15Z" fill="#FF7F36"/>
                          <path d="M18.8333 15V4.99996C18.8333 2.88287 17.1171 1.16663 15 1.16663H12.0513C10.6422 1.16663 9.5 2.30887 9.5 3.71791V16.282C9.5 17.691 10.6422 18.8333 12.0513 18.8333H15C17.1171 18.8333 18.8333 17.1171 18.8333 15Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M14.9987 14.5833C14.9987 15.0436 14.6256 15.4167 14.1654 15.4167C13.7051 15.4167 13.332 15.0436 13.332 14.5833C13.332 14.1231 13.7051 13.75 14.1654 13.75C14.6256 13.75 14.9987 14.1231 14.9987 14.5833Z" fill="white"/>
                          <path d="M6.66667 14.5833C6.66667 15.0436 6.29357 15.4167 5.83333 15.4167C5.3731 15.4167 5 15.0436 5 14.5833C5 14.1231 5.3731 13.75 5.83333 13.75C6.29357 13.75 6.66667 14.1231 6.66667 14.5833Z" fill="white"/>
                          <path d="M12.9154 5.83337H15.4154M4.58203 5.83337H7.08203M12.9154 9.16671H15.4154M4.58203 9.16671H7.08203" stroke="white" stroke-width="0.923077" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <span>Cabinets</span>
                      </span>
                      <span style="font-family: 'Open Sans';
                      font-size: 14px;
                      font-weight: 600;
                      line-height: 18.2px;">${cabinetCount}</span>
                    </span>
                    <span style="display: flex; justify-content: space-between; align-items: center;">
                      <span style="display: flex; align-items: center; gap: 5px;">
                        <svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M11.3538 1.96555L15.5205 3.89001C16.0327 4.12661 16.4675 4.48718 16.7979 4.92886L14.1826 6.23652L7.43465 2.52513L8.6462 1.96555C9.50809 1.56747 10.4919 1.56747 11.3538 1.96555ZM5.74283 3.30653L4.47954 3.89001C3.96709 4.12669 3.5322 4.48743 3.20171 4.92933L9.99935 8.32815L12.5522 7.05171L5.74283 3.30653ZM2.58096 6.29601C2.52777 6.54205 2.5 6.79646 2.5 7.05547V12.9452C2.5 14.3141 3.27578 15.5547 4.47954 16.1106L8.6462 18.0351C8.84192 18.1255 9.04392 18.1954 9.24935 18.2447V9.6302L2.58096 6.29601ZM10.7493 18.245C10.9552 18.1957 11.1577 18.1257 11.3538 18.0351L13.416 17.0826V8.29687L10.7493 9.6302V18.245ZM14.916 16.3898L15.5205 16.1106C16.7242 15.5547 17.5 14.3141 17.5 12.9452V7.05547C17.5 6.79626 17.4722 6.54165 17.4189 6.29542L14.916 7.54687V16.3898Z" fill="#00C0EF"/>
                        </svg>
                        <span>Stocks</span>
                      </span>
                      <span style="font-family: 'Open Sans';
                      font-size: 14px;
                      font-weight: 600;
                      line-height: 18.2px;">${storeCount}</span>
                    </span>
                    `;
          }
        }else{
          this.warningMessageGeoChart = "No Data at this moment to view";
        }
      },
      error: (error) => {
        if (error) {
          this.warningMessageGeoChart = "Something went wrong";
        }
      },
      complete: () => console.info('complete') 
    });
  }


  getStockCounts(){
    this.analyticsService.getStocks(['active','consumed','missing','expired','transit']).subscribe({
      next: (res) => {
        if (res.data) {
          this.stocks.forEach((stock)=> {
            if (res.data[stock.name]) {
              stock.count = res.data[stock.name]
            }
          })
        } 
      },
      error: (error) => {
        if (error) {
        }
      },
      complete: () => console.info('complete') 
    });
  }

  getConsumedByWeek(){
    this.analyticsService.getConsumed('day_intervals', 'week').subscribe({
      next: (res) => {
        if (res.data) {
          this.warningMessageConsumedByWeek = "";
          this.generateChart(res.data)
        }else{
          this.warningMessageConsumedByWeek = "No stock consumed at this moment to view";
        }
      },
      error: (error) => {
        if (error) {
          this.warningMessageConsumedByWeek = "Something went wrong";
        }
      },
      complete: () => console.info('complete') 
    });
  }

  getConsumedByStores(type: string){
    if (type === 'consumed') {
      this.analyticsService.getConsumed('stores').subscribe({
        next: (res) => {
          if (res.data) {
            this.warningMessageConsumedByStores = "";
            this.donutLegendStoreType = [];
            this.generateDognutChart(res.data, "consumed-stores", this.donutLegendStoreType);
          }else{
            this.warningMessageConsumedByStores = "No stock consumed at this moment to view";
          }  
        },
        error: (error) => {
          if (error) {
            this.warningMessageConsumedByStores = "Something went wrong";
          }
        },
        complete: () => console.info('complete') 
      });
    }else{
      this.analyticsService.getMissing('stores').subscribe({
        next: (res) => {
          if (res.data) {
            this.warningMessageConsumedByStores = "";
            this.donutLegendStoreType = [];
            this.generateDognutChart(res.data, "consumed-stores", this.donutLegendStoreType);
          }else{
            this.warningMessageConsumedByStores = "No stock missing at this moment to view";
          }  
        },
        error: (error) => {
          if (error) {
            this.warningMessageConsumedByStores = "Something went wrong";
          }
        },
        complete: () => console.info('complete') 
      });
    }
  }

  getConsumedByProducts(type: string){
    this.analyticsService.getConsumed('product_types', '', type).subscribe({
      next: (res) => {
        if (res.data) {
          this.warningMessageConsumedByProducts = "";
          this.donutLegendProductType = [];

          this.generateDognutChart(res.data, 'consumed-product-types', this.donutLegendProductType);
        }else{
          this.warningMessageConsumedByProducts = "No stock consumed at this moment to view";
        }  
      },
      error: (error) => {
        if (error) {
          this.warningMessageConsumedByProducts = "Something went wrong";
        }
      },
      complete: () => console.info('complete') 
    });
  }

  getExpired(){
    this.analyticsService.getExpired('stores').subscribe({
      next: (res) => {
        if (res.data.data.length !== 0) {
          this.warningMessageExpired = "";
          this.expiredStocks = res.data.data;          
        }else{
          this.warningMessageExpired = "No stock expired at this moment to view";
        }  
      },
      error: (error) => {
        if (error) {
          this.warningMessageExpired = "Something went wrong";
        }
      },
      complete: () => console.info('complete') 
    });
  }

  getExpiring(){
    this.analyticsService.getExpiring().subscribe({
      next: (res) => {
        if (res.data.data.length !== 0) {
          this.warningMessageExpiring = "";
          this.expiringStocks = res.data.data;
        }else{
          this.warningMessageExpiring = "No stock about to expiry at this moment to view";
        }  
      }, 
      error: (error) => {
        if (error) {
          this.warningMessageExpiring = "Something went wrong";
        }
      },
      complete: () => console.info('complete') 
    });
  }

  generateChart(chartData): void {
    const ctx = document.getElementById('consumed-week') as HTMLCanvasElement;
    
    new Chart(ctx, {
      type: 'bar',
      data: {
        labels: chartData.labels,
        datasets: chartData.datasets.map(dataset => ({
          label: dataset.label,
          data: dataset.data,
          backgroundColor: dataset.backgroundColor || '#2386DB',
          borderWidth: dataset.borderWidth || 1
        }))   
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            display: false,
            position: 'top'
          },
          tooltip: {
            displayColors: false,
            titleAlign: 'center',
            enabled: true,
            cornerRadius: 5,
            padding: 10,
            backgroundColor: "#ffffff",
            bodyFont: {
              size: 15
            },
            borderColor: '#DDDDDD',
            borderWidth: 1,
            titleColor: "#1C1F37",
            xAlign: 'center',
            yAlign: 'bottom',
            callbacks: {
              labelTextColor: function(context) {
                return '#1C1F37';
              }
            }
          },
          title: {
            display: false
          }
        },
        scales: {
          x: {
            grid: {
              display: false 
            }
          },
          y: {
            grid: {
              display: true 
            },
            title: {
              display: true,
              text: 'Quantity', 
              align: 'center', 
              color: '#666666',
              font: {
                size: 13,
                family: 'Open Sans'
              },
              padding: 4
            }
          }
        }
      }
    });
  } 

  generateDognutChart(chartData, chartId: string, legend: Array<any>): void {

    const existingChart = Chart.getChart(chartId);

    if (existingChart) {
        existingChart.destroy();
    }

    const ctx = document.getElementById(chartId) as HTMLCanvasElement;

    const chart = new Chart(ctx, {
      type: 'doughnut',
      data: {
        labels: chartData.labels,
        datasets: chartData.datasets
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            displayColors: false,
            titleAlign: 'center',
            enabled: true,
            usePointStyle: true,
            cornerRadius: 20,
            padding: 10,
            backgroundColor: "#ffffff",
            bodyFont: {
              size: 20
            },
            xAlign: 'left',
            yAlign: 'bottom',
            borderColor: "#DDDDDD",
            borderWidth: 1,
            callbacks: {
              title(tooltipItems) {
                return '';
              },
              label: function(tooltipItem) {
                let part = tooltipItem.dataset.data[tooltipItem.dataIndex];
                let percentage = Math.round((part / chartData.totalStock) * 100);
                
                return `${percentage}%`;
              },
              labelColor: (tooltipItem) => {                
                return {
                  borderColor: '#ffffff',
                  backgroundColor: '#ffffff',
                  padding: {
                      top: 20,
                      bottom: 20,
                      left: 20,
                      right: 20
                  },
                  align: 'center'
              };
              },
              labelTextColor: function(context) {
                return '#1C1F37';
              }
            }
          },
          datalabels: {
            color: '#000000',
            anchor: 'end',
            align: 'start',
            offset: 0,
            font: {
              size: 16
            }
          }
        },
      },
    });

    const datasets = chart.data.datasets;
    
    datasets[0].data.map((data, i) => {
      legend.push({
        label: chart.data.labels[i],
        backgroundColor: datasets[0].backgroundColor[i],
        count: data
      });
    })
    
  }

  switchStoresChart(event, type){
    let tabGroup = event.target.closest('.tab-group');

    const tabs = tabGroup.getElementsByClassName('tab');

    Array.from(tabs).forEach((tab: any)=> {
      tab.classList.remove('active');
    })

    event.target.classList.add('active');

    this.getConsumedByStores(type);

  }

  switchProductsChart(event, type){
    let tabGroup = event.target.closest('.tab-group');

    const tabs = tabGroup.getElementsByClassName('tab');

    Array.from(tabs).forEach((tab: any)=> {
      tab.classList.remove('active');
    })

    event.target.classList.add('active');

    this.getConsumedByProducts(type);

  }

  onResize(){
    console.log('true');

  }
}
